"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTypingIndicatorStyle;

function createTypingIndicatorStyle(_ref) {
  var paddingRegular = _ref.paddingRegular;
  return {
    paddingBottom: paddingRegular,
    '&:not(.webchat__typingIndicator--rtl)': {
      paddingLeft: paddingRegular
    },
    '&.webchat__typingIndicator--rtl': {
      paddingRight: paddingRegular
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvVHlwaW5nSW5kaWNhdG9yLnRzIl0sIm5hbWVzIjpbImNyZWF0ZVR5cGluZ0luZGljYXRvclN0eWxlIiwicGFkZGluZ1JlZ3VsYXIiLCJwYWRkaW5nQm90dG9tIiwicGFkZGluZ0xlZnQiLCJwYWRkaW5nUmlnaHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFFZSxTQUFTQSwwQkFBVCxPQUE0RTtBQUFBLE1BQXRDQyxjQUFzQyxRQUF0Q0EsY0FBc0M7QUFDekYsU0FBTztBQUNMQyxJQUFBQSxhQUFhLEVBQUVELGNBRFY7QUFHTCw2Q0FBeUM7QUFDdkNFLE1BQUFBLFdBQVcsRUFBRUY7QUFEMEIsS0FIcEM7QUFPTCx1Q0FBbUM7QUFDakNHLE1BQUFBLFlBQVksRUFBRUg7QUFEbUI7QUFQOUIsR0FBUDtBQVdEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTdHJpY3RTdHlsZU9wdGlvbnMgfSBmcm9tICdib3RmcmFtZXdvcmstd2ViY2hhdC1hcGknO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjcmVhdGVUeXBpbmdJbmRpY2F0b3JTdHlsZSh7IHBhZGRpbmdSZWd1bGFyIH06IFN0cmljdFN0eWxlT3B0aW9ucykge1xuICByZXR1cm4ge1xuICAgIHBhZGRpbmdCb3R0b206IHBhZGRpbmdSZWd1bGFyLFxuXG4gICAgJyY6bm90KC53ZWJjaGF0X190eXBpbmdJbmRpY2F0b3ItLXJ0bCknOiB7XG4gICAgICBwYWRkaW5nTGVmdDogcGFkZGluZ1JlZ3VsYXJcbiAgICB9LFxuXG4gICAgJyYud2ViY2hhdF9fdHlwaW5nSW5kaWNhdG9yLS1ydGwnOiB7XG4gICAgICBwYWRkaW5nUmlnaHQ6IHBhZGRpbmdSZWd1bGFyXG4gICAgfVxuICB9O1xufVxuIl19